import Modal from "src/components/common/modal";
import { myOptions } from "src/components/personel/userForm";
import { useMyStore } from "src/components/main/mainStore";
import dayOffsTypes from "./dayOffsTypes";
//--------------------------------------------------------------------------------------------
export default function FilterForm({
    closeIt, setCurrentPage,
    curFilter, setFilter, usersList,
    defaultFilter
}){
    const curUser = useMyStore(state => state.user);
    return (
        <Modal
            touchOutsideClose = {true}
            closeIt = {closeIt}
            title = "Filter"
            width = {650}
            maxWidth = {"100%"}
        >
            <div className = "m-3">
                <span className = "mr-3 font-weight-bold">Validity:</span>
                <select className = "form-control inline" value = {curFilter.void} onChange = {e => setFilter({...curFilter, void: e.currentTarget.value})}>
                    <option value = "">Valid</option>
                    <option value = "yes">Void</option>
                    <option>All</option>
                </select>
                {
                curFilter.void?
                <span style = {{marginLeft: 10}} onClick = {() => {setFilter({...curFilter, void: ""})}}>❌</span>:
                null
                }
            </div>
            <div className = "m-3 row">
                <span className = "mr-3 font-weight-bold" style = {{alignSelf: "center"}}>Created By Me:</span>
                <input
                    type = "checkbox"
                    style = {{width: 30, height: 30}}
                    checked = {curFilter.createdByMe}
                    onChange = {e => setFilter({...curFilter, createdByMe: e.currentTarget.checked})}
                />
                {
                curFilter.createdByMe?
                <span style = {{marginLeft: 10}} onClick = {() => {setFilter({...curFilter, createdByMe: false})}}>❌</span>:
                null
                }
            </div>
            <div className = "m-3 row">
                <span className = "mr-3 font-weight-bold" style = {{alignSelf: "center"}}>Updated By Me:</span>
                <input
                    type = "checkbox"
                    style = {{width: 30, height: 30}}
                    checked = {curFilter.updatedByMe}
                    onChange = {e => setFilter({...curFilter, updatedByMe: e.currentTarget.checked})}
                />
                {
                curFilter.updatedByMe?
                <span style = {{marginLeft: 10}} onClick = {() => {setFilter({...curFilter, updatedByMe: false})}}>❌</span>:
                null
                }
            </div>
            {curUser.projects === "no"?null:<>
            <div className = "m-3">
                <span className = "mr-3 font-weight-bold">Requester:</span>
                <select className = "form-control inline" value = {curFilter.requesterEmail} onChange = {e => {
                    setFilter({...curFilter, requesterEmail: e.currentTarget.value.toLowerCase()});
                    setCurrentPage(1);
                }}>
                    <option value = "">Select</option>
                    {usersList.map((user, userIndex) => 
                    <option key = {userIndex} value = {user.value}>
                        {user.label}
                    </option>)}
                </select>
                {
                curFilter.requesterEmail !== ""?
                <span style = {{marginLeft: 10}} onClick = {() => {setFilter({...curFilter, requesterEmail: ""})}}>❌</span>:
                null
                }
            </div>
            <div className = "m-3">
                <span className = "mr-3 font-weight-bold">Department:</span>
                <select className = "form-control inline" value = {curFilter.department} onChange = {e => {
                    setFilter({...curFilter, department: e.currentTarget.value});
                    setCurrentPage(1);
                }}>
                    <option value = "">Select</option>
                    {Object.entries(myOptions.department).map(([key, value], k) => <optgroup label = {key} key = {k}>{value.map((v, vi) => <option key = {vi}>{v}</option>)}</optgroup>)}
                </select>
                {
                curFilter.department !== ""?
                <span style = {{marginLeft: 10}} onClick = {() => {setFilter({...curFilter, department: ""})}}>❌</span>:
                null
                }
            </div>
            </>}
            <div className = "m-3">
                <span className = "mr-3 font-weight-bold">Request Date:</span>
                <input 
                    type = "date" 
                    min = "1900-01-01"
                    max = "2999-12-31"
                    className = "form-control" 
                    value = {curFilter.requestDate} 
                    onChange = {e => setFilter({
                        ...curFilter, 
                        requestDate: e.currentTarget.value
                    })}
                />
                {
                curFilter.requestDate?
                <span style = {{marginLeft: 10}} onClick = {() => {setFilter({...curFilter, requestDate: ""})}}>❌</span>:
                null
                }
            </div>
            <div className = "m-3">
                <span className = "mr-3 font-weight-bold">Request Date 2:</span>
                <input 
                    type = "date" 
                    min = "1900-01-01"
                    max = "2999-12-31"
                    className = "form-control" 
                    value = {curFilter.requestDate2} 
                    onChange = {e => setFilter({
                        ...curFilter, 
                        requestDate2: e.currentTarget.value
                    })}
                />
                {
                curFilter.requestDate2?
                <span style = {{marginLeft: 10}} onClick = {() => {setFilter({...curFilter, requestDate2: ""})}}>❌</span>:
                null
                }
            </div>
            <div className = "m-3">
                <span className = "mr-3 font-weight-bold">Total Hours:</span>
                <span className = "blk">
                    <span className = "mr-3">min:</span>
                    <input
                        type = "number"
                        className = "mr-3 form-control inline"
                        step = {2}
                        value = {curFilter.totalMin}
                        onChange = {e => {
                            setFilter({...curFilter, totalMin: e.currentTarget.value});
                            setCurrentPage(1);
                        }}
                    />
                </span>
                <span className = "blk">
                    <span className = "mr-3">max:</span>
                    <input
                        type = "number"
                        className = "form-control inline"
                        step = {2}
                        value = {curFilter.totalMax}
                        onChange = {e => {
                            setFilter({...curFilter, totalMax: e.currentTarget.value});
                            setCurrentPage(1);
                        }}
                        
                    />
                </span>
                {
                curFilter.totalMax || curFilter.totalMin?
                <span style = {{marginLeft: 10}} onClick = {() => {setFilter({...curFilter, totalMin: "", totalMax: ""})}}>❌</span>:
                null
                }
            </div>
            <div className = "m-3">
                <span className = "mr-3 font-weight-bold">Type:</span>
                <select className = "form-control inline" value = {curFilter.type} onChange = {e => setFilter({...curFilter, type: e.currentTarget.value})}>
                    <option value = "">Select</option>
                    {dayOffsTypes.map((type, typei) => <option key = {typei}>{type}</option>)}
                </select>
                {
                curFilter.type?
                <span style = {{marginLeft: 10}} onClick = {() => {setFilter({...curFilter, type: ""})}}>❌</span>:
                null
                }
            </div>
            <div className = "m-3">
                <span className = "mr-3 font-weight-bold">Approver:</span>
                <select className = "form-control inline" value = {curFilter.approverEmail} onChange = {e => {
                    setFilter({...curFilter, approverEmail: e.currentTarget.value.toLowerCase()});
                    setCurrentPage(1);
                }}>
                    <option value = "">Select</option>
                    {usersList.filter(user => user.purchases === "approver")
                    .map((user, userIndex) => 
                    <option key = {userIndex} value = {user.value}>
                        {user.label}
                    </option>)}
                </select>
                {
                curFilter.approverEmail !== ""?
                <span style = {{marginLeft: 10}} onClick = {() => {setFilter({...curFilter, approverEmail: ""})}}>❌</span>:
                null
                }
            </div>
            <div className = "m-3">
                <span className = "mr-3 font-weight-bold">Status:</span>
                <select className = "form-control inline" value = {curFilter.status} onChange = {e => {
                    setFilter({...curFilter, status: e.currentTarget.value});
                    setCurrentPage(1);
                }}>
                    <option value = "">Select</option>
                    <option>Submitted</option>
                    <option>Re-Submitted</option>
                    <option>Approved</option>
                    <option>Rejected</option>
                </select>
                {
                curFilter.status?
                <span style = {{marginLeft: 10}} onClick = {() => {setFilter({...curFilter, status: ""})}}>❌</span>:
                null
                }
            </div>
            <div className = "mt-5 mb-3">
                <span className = "btn btn-secondary" onClick = {() => {
                    setFilter(defaultFilter);
                    setCurrentPage(1);
                }}>Clear Filter</span>
            </div>
        </Modal>
    )
}